import Vue from 'vue'
import {
  _COMMIT_LOG, _PROCESS_ERROR, PLAN_GET_PLANS, PLAN_PROCESS_PLANS,
} from './actions.types'
import {
  PLAN_ADD_PLAN, PLAN_SET_ACTIVE, PLAN_RESET_PLANS,
} from './mutations.types'

import PlanService from '../services/plan.service'

const initialState = {
  activeKey: '0',
  byKey: {
    0: {
      display_text: '-Select One-',
      Id: '',
    },
  },
  allKeys: ['0'],
}

export const state = { ...initialState }

export const actions = {
  async [PLAN_GET_PLANS] ({ dispatch, commit, rootState }, payload) {
    try {
      await dispatch(_COMMIT_LOG, { message: 'Retrieving plans with payload', payload }, { root: true })
      const response = await PlanService.query()
      await dispatch(_COMMIT_LOG, { message: 'Response from get plans', response: response.data }, { root: true })
      await dispatch(PLAN_PROCESS_PLANS, response.data)
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  async [PLAN_PROCESS_PLANS] ({ dispatch, commit, rootState, state }, objects) {
    commit(PLAN_RESET_PLANS)
    try {
      objects.forEach((obj) => {
        commit(PLAN_ADD_PLAN, obj)
      })
      return true
    } catch (e) {
      dispatch(_COMMIT_LOG, { message: 'Exception thrown processing plans', error: e }, { root: true })
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },

}

export const mutations = {
  [PLAN_ADD_PLAN]: (state, item) => {
    Vue.set(state.byKey, item.Id, item)
    if (state.allKeys.includes(item.Id)) return
    state.allKeys.push(item.Id)
  },
  [PLAN_RESET_PLANS]: (state) => {
    state.byKey = { ...initialState.byKey }
    state.allKeys = [...initialState.allKeys]
  },
  [PLAN_SET_ACTIVE]: (state, item) => {
    if (item && item.Id) {
      state.activeKey = item.Id
    } else {
      state.activeKey = item
    }
  },

}
export const getters = {
  activeKey: state => state.activeKey,
  // Return the active organization
  activePlan: (state, getters) => {
    return getters.find(state.activeKey)
  },
  // Return a single item with the given key
  find: (state, _, __, rootGetters) => key => {
    return state.byKey[key]
  },
  // Return a list of items in the order of `allKeys`.
  list: (state, getters) => {
    return state.allKeys.map(Id => getters.find(Id)).filter((org) => { return org.Id !== '' })
  },
  // Return a list of organizations in the order of `allKeys`.
  listHome: (state, getters) => {
    return state.allKeys.map(rowkey => getters.find(rowkey))
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
